import { Section, Sections } from "types/Checklist";

export const useCalculateNumParagraphColumns = (sections: Sections) => {
  let numParagraphColumns = undefined as number | undefined;

  for (var section of sections) {
    if (
      section.displayParagraphColumns &&
      section.paragraphPositionsData &&
      section.paragraphPositionsData.length > 1 &&
      section.paragraphPositionsData.length > (numParagraphColumns ?? 1)
    ) {
      numParagraphColumns = section.paragraphPositionsData.length;
    }

    if (section.sections) {
      const subSectionNumParagraphColumns = useCalculateNumParagraphColumns(
        section.sections
      );

      if ((subSectionNumParagraphColumns ?? 1) > (numParagraphColumns ?? 1)) {
        numParagraphColumns = subSectionNumParagraphColumns;
      }
    }
  }

  return numParagraphColumns;
};
